const customColors = {
    background: '#FAFAFA',
    dialogTitleBackground: '#373435',
    primary: '#000000',
    secondary: '#FAFAFA',
    white: '#FFFFFF',
    darkGrey1: '#373435',
    darkGrey2: '#242223',
    grey: '#9B9B9B',
    red: '#FF0000',
    blue: '#1763A9',
};

export default customColors;
